export default {
    "baseURL":'http://ssj.rb-china.com',
    // "baseURL":'http://www.fychina.cn',
    "sentry":{
        "version":"v1.0.0"
    }
}